module.exports = __webpack_public_path__ + "img/4-en.f24be012.jpg";